import React, {useState, useMemo} from 'react';
import {useLocation, useHistory} from 'react-router';
import {connect, useDispatch} from 'react-redux';
import qs from 'qs';
import update from 'immutability-helper';
import {container} from 'op/container';
import {compose} from 'recompose';
import {hot} from 'react-hot-loader';
import {Button, Form, Message, Dimmer, Loader} from 'semantic-ui-react';

import ReportMeta from 'op/components/report/meta';

import {withAxios} from 'op/components/auth';
import {withLocale} from 'op/components/locale';

import {createReportBase} from '../create'
import {validateReport} from '../report.helper'
import url from "url";
import {withKpiTypes, withExecutionLevels} from 'op/components/lut'


const ReportCreateBulk = ({locale, language, axios,person}) => {
    
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [submitting, setSubmitting] = useState(false);
    const [dirty, setDirty] = useState(false);
    const query = useMemo(() => qs.parse(location.search.substr(1)), [location.search]);
    const [reports, setReports] = useState((query.p || []).map(id => createReportBase({person_id:id,hidden_person_id: person.loaded.find(p => p.id == id).person_id})));
    const validation = useMemo(() => validateReport(reports[0]));


    const invokeChange = (change) => setReports(reports.map(report => update(report, change)));

    const callKpi = async () => {
        try {
            for (const report of reports) {
                let catID = report.category.toString();
                const kpis = await axios.post('/api/kpi/sub_eval_type', {categoryID: report.category});
                let _data = kpis.data.map(container.resolve('transformers').kpiType)
                dispatch(container.resolve('actions').load_complex_table({table: 'kpis', type: catID, payload: _data}));

                //------------------------------------------------------------------------
                let typeID = report.type.id.toString();
                const exlvl = await axios.get(url.format({
                    pathname: '/api/common/getexecutionlevels',
                    query: {traningEventType: typeID, language: language || 1}
                }));

                let ex_lvl = exlvl.data.map(container.resolve('transformers').execution_level);
                dispatch(container.resolve('actions').load_complex_table({table: 'executionLevels', type: typeID, payload: ex_lvl}));
            }
        } catch (err) {
            console.error(err);
        }
    };

    const submitChange = async () => {
        if (!dirty) {
            setDirty(true);
        }

        if (validation.ok) {
            const createdReports = [];
            withKpiTypes();

            setSubmitting(true);

            try {
                for (const report of reports) {
                    const {data: [rawReport]} = await axios.post('/api/tasks/task_save', {
                        languageID: language,
                        IsSimfoxData: 0,
                        ...container.resolve('transformers').report.reverse({
                            ...report,
                            completed: false,
                            id: isNaN(report.id) ? undefined : report.id
                        }),
                    });
                    createdReports.push(container.resolve('transformers').report(rawReport));

                }

                dispatch(createdReports.map(report => container.resolve('actions').save_report(report)));
                callKpi();
                history.push({pathname: '/pending'});
            } finally {
                setSubmitting(false);
            }
        }
    }

    return (
        <Form error={dirty && !validation.ok}>
            <Dimmer active={submitting} inverted page>
                <Loader/>
            </Dimmer>
            <ReportMeta {...{report: reports[0], invokeChange}} />
            <Message
                error
                header={locale._system.validation.negative}
                content={validation.message}
            />
            <Button fluid primary onClick={submitChange}
                    disabled={dirty && !validation.ok}>{locale._system.createTask}</Button>
        </Form>
    );
}

export default compose(
    withLocale(),
    withAxios,
    withKpiTypes,
    hot(module),
    connect(({ person }) => ({
		person: person
	}))	
)(ReportCreateBulk)